export const ItemTypes = {
    NAVBAR: 'navbar',
    BODY: 'body',
    FOOTER: 'footer',
  }


  